import { AUTH_TOKEN } from "redux/constants/Auth";
import {
  GET_EXPORT_NON_CAMP_INMATES_DATA,
  SET_ALL_CREATE_EARTHQUAKE_NON_INMATES_REGISTRATION,
  SET_ALL_EARTHQUAKE_NON_INMATES_REGISTRATION,
  SET_ALL_UPDATE_EARTHQUAKE_NON_INMATES_REGISTRATION,
  SET_EXPORT_NON_CAMP_INMATES_DATA,
  SET_EARTHQUAKE_NON_INMATES_REGISTRATION,
} from "redux/constants/EarthquakeNonInmatesRegistration";

// Define an initial state
const initialState = {
  earthquakeNonInmatesRegistrationData: [],
  earthquakeIsNonInmatesRegistrationDataFetched: false,
  earthquakeNonInmatesRegistrationListingParam: {},
  earthquakeNonCampInmatesRegistrationExportedData: {},
  token: localStorage.getItem(AUTH_TOKEN),
};

// Reducer function
const earthquakeNonInmatesRegistration = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_EARTHQUAKE_NON_INMATES_REGISTRATION:
      return {
        ...state,
        earthquakeNonInmatesRegistrationData: action.payload,
        earthquakeIsNonInmatesRegistrationDataFetched:
          Object.keys(action.payload).length > 0 ? true : false,
      };

    case SET_ALL_CREATE_EARTHQUAKE_NON_INMATES_REGISTRATION:
      // Handle the logic to create a new report here
      // You can update the state accordingly
      // For example, if you want to store the new report data, you can do something like this:

      return {
        ...state,
        earthquakeNonInmatesRegistrationData: action.payload,
        earthquakeIsNonInmatesRegistrationDataFetched:
          Object.keys(action.payload).length > 0 ? true : false,
      };

    case SET_ALL_UPDATE_EARTHQUAKE_NON_INMATES_REGISTRATION:
      return {
        ...state,
        earthquakeNonInmatesRegistrationData: action.payload,
        earthquakeIsNonInmatesRegistrationDataFetched:
          Object.keys(action.payload).length > 0 ? true : false,
      };

    case SET_EARTHQUAKE_NON_INMATES_REGISTRATION:
      return {
        ...state,
        earthquakeNonInmatesRegistrationListingParam: action.payload,
      };

    case GET_EXPORT_NON_CAMP_INMATES_DATA:
      return {
        ...state,
      };

    case SET_EXPORT_NON_CAMP_INMATES_DATA:
      return {
        ...state,
        earthquakeNonCampInmatesRegistrationExportedData: action.payload,
      };

    default:
      return state;
  }
};

export default earthquakeNonInmatesRegistration;
